import React, { useEffect, useState } from 'react'
import CorePopUp from '../../cvp-webgames-core/Components/ui/react/core-pop-up';
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { TextHtmlTagType, generalAudioCaching, getGlobalTextSizeStyle, parseDynamicHtml } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';

import "./intro-screen-ui.css"
import MentorUI from './mentor-ui';
import MediaControlsUI from './media-controls-ui';
import { constants } from '../../misc/constants';
const mediaId = Tools.generateGuid()

const IntroScreenUI = (props: UIProperties<IntroScreenUIConfig>) => {
	const [isInit, setIsInit] = useState(false);
	useEffect(() => {
		if(!isInit) {
			setIsInit(true);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);
		}
	}, []);
	return (
		<div className="modal-disable-select intro-screen-ui black-overlay" style={{
		}}>
			<div className={`intro-screen-ui-inner center-element ${constants.mainContent508Id}`} aria-label='Content'>
				<CorePopUp title={props.parameters.title} subtitle={props.parameters.subtitle} style={{
					backgroundColor: 'lightgray'
				}} onRenderContent={() => {
					return (
						<div className='intro-screen-ui-content'>
							<div  className='intro-screen-ui-content-content-container main-content-inner' style={{
								height: props.parameters.mentorUrl ? '70%' : '85%'
							}}>
								{props.parameters.htmlData ? (
									<div style={{

									}}>
										{props.parameters.mentorUrl ? <div className='intro-screen-ui-content-content-container-mentor'>
											<MentorUI mediaId={mediaId} talkingVideoSrc={props.parameters.mentorUrl} chapterId={props.parameters.mentorChapter}></MentorUI>
										</div> : (null)}
										
										<div className={`intro-screen-ui-content-content-container-inner${props.parameters.mentorUrl ? '-mentor' : ''} default-text`}>
											<div style={{
												width: '99%'
											}}>
												<h2 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h2)}} className='incident-title text-manual-edit-h2'>Summary</h2>
											</div>
											<div>
												<span style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-recap-first text-manual-edit-p'>{props.parameters.recapFirst}</span>
											</div>
											<div style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-recap text-manual-edit-p' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.htmlData) }}></div>
										</div>
										{props.parameters.mentorUrl ? (
											<div style={{
												width: '990px',
												height: '100px',
												position: 'absolute',
												top: '570px',
												left: '50%',
												transform: 'translatex(-50%)'
											}}>
												<MediaControlsUI mediaId={mediaId}></MediaControlsUI>
											</div>
										) : (null)}
									</div>
								) : (
								<div className='intro-screen-ui-content-content-container-inner default-text'>
									<table>
										<tr>
											<td aria-label='Person Involved in the Incident' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-title text-manual-edit-p'>Person Involved in the Incident</td>
										</tr>
										<tr>
											<td aria-label='Name' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Name: </td>
											<td aria-label={props.parameters.name} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-text text-manual-edit-p'>{props.parameters.name}</td>
										</tr>
										<tr>
											<td aria-label='Position' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Position: </td>
											<td aria-label={props.parameters.position} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-text text-manual-edit-p'>{props.parameters.position}</td>
										</tr>
										<tr>
											<td aria-label='Incident Information'  style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-title text-manual-edit-p'>Incident Information</td>
										</tr>
										<tr>
											<td aria-label='Position' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Time of Incident: </td>
											<td aria-label={props.parameters.time} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-text text-manual-edit-p'>{props.parameters.time}</td>
										</tr>
										<tr>
											<td aria-label='Place of Incident' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Place of Incident: </td>
											<td aria-label={props.parameters.place} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-text text-manual-edit-p'>{props.parameters.place}</td>
										</tr>
										<tr className='incident-desc-top'>
											<td aria-label='Incident Description' style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Incident Description: </td>
										</tr>
										<tr className='incident-desc-bottom'>
											<td aria-label={props.parameters.desc} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='text-manual-edit-p'>{props.parameters.desc}</td>
										</tr>
										<tr>
											<td aria-label={'Are there repeated occurences?'} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-prefilled text-manual-edit-p'>Are there repeated occurences?: </td>
											<td aria-label={props.parameters.repeat} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='incident-text text-manual-edit-p'>{props.parameters.repeat}</td>
										</tr>
									</table>
								</div>)}
								
							</div>
							<div className='intro-screen-ui-content-confirm-bttn-container center-element-horizontal'>
								<Button2 width= '100%'
									idFor508='recap-content-top'
									height= '100%'
									backgroundColor='#157F2F'
									hoverBgColor='#0b491a'
									onClick= {props.parameters.onStartScenarioClicked}
									onRenderContent= {() => {
										return (
											<div>
												<p style={{color: 'white', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='small-text intro-screen-ui-content-btn-confirm-text center-element-vertical text-manual-edit-p'>{props.parameters.okButton}</p>
											</div>
										)
									}}
									isSelected= {false}
									ariaLabel= {props.parameters.okButton}></Button2>
							</div>
						</div>
					);
				}}></CorePopUp>
			</div>
		</div>
	);

};

export interface IntroScreenUIConfig extends BaseConfig {
	title: string;
	subtitle: string;
	htmlData?: string;
	recapFirst?: string;
	name?: string;
	position?: string;
	time?: string;
	place?: string;
	desc?: string;
	repeat?: string;
	okButton: string;
	mentorUrl?: string;
	mentorChapter?: string;
	onStartScenarioClicked?: () => void;
}

export default IntroScreenUI;